<template>
  <div style="width: 100%" ref="parent">
    <div flex="cross:center" v-if="showTag">
      <el-tag
      :key="tag.id"
      v-for="tag in selectDataInfo"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
      effect="plain"
      class="knowledge-point"
      style="margin-left: 0;margin-right: 10px;"
    >
      {{ tag.kpName }}
    </el-tag>

      <div v-popover:popover>
        <div v-if="selectDataInfo.length !== limit">
          <el-button
            v-if="!$slots.default"
            type="text"
            icon="el-icon-circle-plus"
            style="color: #0070C1;font-size: 18px;padding-left: 0;padding-right: 0"
          ></el-button>
          <slot v-else></slot>
        </div>
      </div>

    </div>

    <div v-else>
      <div v-popover:popover>
        <el-button
          v-if="!$slots.default"
          type="text"
          icon="el-icon-circle-plus"
          style="color: #0070C1;font-size: 18px;padding-left: 0;padding-right: 0"
        ></el-button>
        <slot v-else></slot>
      </div>
    </div>

    <el-popover
      placement="bottom"
      trigger="click"
      ref="popover"
      :width="width"
    >
      <div>
        <div style="font-size: 18px;padding-bottom: 10px;">请选择知识点</div>
        <el-select @change="changePoint" style="margin-bottom: 10px;" v-model="selectData" multiple :multiple-limit="3" filterable >
          <el-option v-for="item in pointListAll" :key="item.id" :label="item.kpName" :value="item.id"></el-option>
        </el-select>
        <el-scrollbar style="height: 250px" wrap-class="overflow-x">
          <div class="quick">
            <el-tag style="cursor:pointer;user-select: none" class="knowledge-point" @click="selectPoint(index)" :effect="item.checked ? 'dark' : 'plain'" v-for="(item, index) in pointListAll" :key="item.id">{{ item.kpName }}</el-tag>
          </div>

          <el-empty
            description="暂无数据"
            :image-size="100"
            v-if="!pointList.length"
          ></el-empty>
        </el-scrollbar>
      </div>


    </el-popover>

  </div>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  name: "bc-select-knowledge-point",
  props: {
    pointList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    defaultWidth: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 3
    },
    showTag: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selectData = val;
        this.pointListAll.forEach((i, index) => {
        if (this.selectData.includes(i.id)) {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: true})
        } else {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: false})
        }
      })
      },
      immediate: true,
      deep: true,
    },
    pointList: {
      handler(val) {
        if (Array.isArray(val)) {
          this.pointListAll = XEUtils.clone(val.map(i => ({...i, checked: false})), true)
          this.pointListAll.forEach((i, index) => {
            if (this.value.includes(i.id)) {
              this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: true})
            }
          })
        } else {
          this.pointListAll = []
        }
      },
      immediate: true,
      deep: true
    },
    selectData: {
      handler(val) {
        this.$emit("input", val);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    selectDataInfo() {
      let arr = this.pointList.filter((i) =>
        this.selectData.some((x) => i.id === x)
      );
      return arr;
    },
  },
  data() {
    return {
      selectData: [],
      width: 250,
      selectDataPool: [],

      pointListAll: [],

      queryList: []
    };
  },
  mounted() {
    this.width = this.defaultWidth || this.$refs.parent.offsetWidth
  },
  methods: {
    selectPoint(index) {

      if (this.limit !== -1) {
        let have = this.pointListAll.filter(i => i.checked)
        if (have.length >= this.limit && !this.pointListAll[index].checked) {
          this.$message.error('知识点最多选择三个')

          return
        }
      }


      let data = this.pointListAll[index]
      this.$set(this.pointListAll, index, {...data, checked: !data.checked})
      this.selectData = this.pointListAll.filter(i => i.checked).map(i => i.id)


    },
    changePoint() {
      this.pointListAll.forEach((i, index) => {
        if (this.selectData.includes(i.id)) {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: true})
        } else {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: false})
        }
      })
    },
    handleClose(tag) {
      this.selectData.splice(this.selectData.indexOf(tag.id), 1);
      this.pointListAll.forEach((i, index) => {
        if (this.selectData.includes(i.id)) {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: true})
        } else {
          this.$set(this.pointListAll, index, {...this.pointListAll[index], checked: false})
        }
      })
    },
    cancel() {
      this.selectDataPool = this.selectData
      this.$refs.popover.doClose();
    },
    confirm() {
      this.selectData = this.selectDataPool;
      this.$refs.popover.doClose();
    },
    // filterMethod(val) {
    //   let query = this.pointList.filter(i => i.kpName.includes(val))
    //   this.queryList = query
    // }
  },
};
</script>

<style scoped lang="scss">
.el-checkbox {
  width: 100%;
}

//.el-tag + .el-tag {
//  margin-left: 0;
//}


.quick {
  ::v-deep .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    margin-left: 0;
  }
}

.el-tag.knowledge-point.el-tag--dark {
  color: #fff;
}

::v-deep .knowledge-point {
  .el-icon-close {
    background-color: #8A8A8A !important;
    font-size: 10px;
    color: #fff;
  }
}
</style>
